// Self-XSS（コンソールへのスクリプト貼り付けを誘導する詐欺）対策として、
// ページ初期ロード時にコンソールへ警告を表示する

type WarningMessages = {
  title: string
  body: string
  action: string
  recruit: string
}

const TITLE_STYLE = [
  'color: #ff1744;',
  'font-size: 48px;',
  'font-weight: bold;',
  'text-shadow: 1px 1px 2px rgba(0,0,0,0.2);',
].join(' ')

// 本文は色を指定せず、DevTools のテーマ（ライト/ダーク）に合った既定の文字色で表示する
const BODY_STYLE = [
  'font-size: 16px;',
  'line-height: 1.6;',
  'font-weight: 500;',
].join(' ')

const ACTION_STYLE = [
  'font-size: 18px;',
  'line-height: 1.6;',
  'color: #ff1744;',
  'font-weight: bold;',
].join(' ')

const RECRUIT_STYLE = [
  'font-size: 14px;',
  'line-height: 1.6;',
  'color: #808080;',
].join(' ')

const MESSAGES_JA: WarningMessages = {
  title: '%cSTOP！',
  body:
    '%cこれは開発者向けのブラウザー機能です。\n' +
    '「ここにコードを貼り付ければコインがもらえる・裏技が使える」などの話は、すべてあなたのアカウント（アバター）を奪い取るための詐欺です。\n\n' +
    'ここにコードを貼り付けると、悪意のある第三者にアカウントを乗っ取られたり、所持コインや大切なアバター、データを盗まれる危険があります。',
  action:
    '%c何をしているか正確に理解していない場合は、今すぐこのウィンドウを閉じてください。',
  recruit:
    '%c何をしているか正確に理解している場合は、 https://reality.inc/jobs/ をご覧ください。',
}

const MESSAGES_EN: WarningMessages = {
  title: '%cSTOP!',
  body:
    '%cThis is a browser feature intended for developers.\n' +
    'If someone told you to copy and paste code here to get free Coins, unlock secret features, or anything else, it is a SCAM to steal your account (avatar).\n\n' +
    'Pasting code here allows attackers to take over your account and steal your Coins, your avatar, and your personal data.',
  action:
    '%cUnless you understand exactly what you are doing, close this window and stay safe.',
  recruit:
    '%cIf you understand exactly what you are doing, check out https://reality.inc/jobs/',
}

export function initSelfXssWarning(): void {
  if (typeof window === 'undefined' || typeof window.console === 'undefined')
    return

  const isJa = navigator.language?.toLowerCase().startsWith('ja')
  const messages = isJa ? MESSAGES_JA : MESSAGES_EN

  // Terser の drop_console は根元が `console` のプロパティアクセスを除去するため、window.console 経由で参照して除去されないようにする
  const log = window.console.log.bind(window.console)

  log(messages.title, TITLE_STYLE)
  log(messages.body, BODY_STYLE)
  log(messages.action, ACTION_STYLE)
  log(messages.recruit, RECRUIT_STYLE)
}
